module.exports = require('./helpers/bundle-url').getBundleURL('9rAa3') + "opsgenie-left.49c0f64b.svg";